type AcceptedPaymentMethodsContainerProps = { children: React.ReactNode };

const AcceptedPaymentMethodsContainer = ({ children }: AcceptedPaymentMethodsContainerProps) => {
	return <div className={`vtex-store-footer-2-x-acceptedPaymentMethodContainer nh2 flex`}>{children}</div>;
};

export default AcceptedPaymentMethodsContainer;
